export default __webpack_public_path__ + "static/media/GES_C.23cd0362.png";